import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { AuthProvider } from './context/AuthContext.jsx';
import { checkAndClearCacheIfVersionChanged } from './config/version';

// Check and clear cache if app version changed
checkAndClearCacheIfVersionChanged();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
